export const ORDERS_LIST_CONNECTION_OPEN: 'ORDERS_LIST_CONNECTION_OPEN' = 'ORDERS_LIST_CONNECTION_OPEN';
export const ORDERS_LIST_CONNECTION_CLOSE: 'ORDERS_LIST_CONNECTION_CLOSE' = 'ORDERS_LIST_CONNECTION_CLOSE';
export const ORDERS_LIST_CONNECTION_SUCCESS: 'ORDERS_LIST_CONNECTION_SUCCESS' = 'ORDERS_LIST_CONNECTION_SUCCESS';
export const ORDERS_LIST_CONNECTION_ERROR: 'ORDERS_LIST_CONNECTION_ERROR' = 'ORDERS_LIST_CONNECTION_ERROR';
export const ORDERS_LIST_CONNECTION_CLOSED: 'ORDERS_LIST_CONNECTION_CLOSED' = 'ORDERS_LIST_CONNECTION_CLOSED';
export const ORDERS_LIST_RECEIVED: 'ORDERS_LIST_RECEIVED' = 'ORDERS_LIST_RECEIVED';
